import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import xtend from 'xtend';
import Listing from './TechnicianSchedule';
import { DATE_FORMATS } from '../../../utils/Formatter';
import _ from 'underscore';

function formatDate (date) {
    return date.format(DATE_FORMATS.apiDateFormat);
}

var ScheduleController = createReactClass({

    propTypes: {
        store: pt.func.isRequired,
        actions: pt.shape({
            get: pt.func.isRequired,
            setFilter: pt.func.isRequired
        }).isRequired
    },

    handleSubmit: function (query) {
        // pass strings, not `moments`
        var q = _(query).mapObject(formatDate);
        this.props.actions.setFilter(q);
    },

    getInitialState: function () {
        return this.props.store();
    },

    handleTechChange: function (id) {
        this.props.actions.setFilter({ id: id });
    },

    componentWillMount: function () {
        var self = this;
        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });
        this.props.actions.get();
    },

    componentWillUnmount: function () {
        this.removeListener();
    },

    render: function () {
        return <Listing
            onSubmit={this.handleSubmit}
            onTechChange={this.handleTechChange}
            {...this.state}
        />;
    }
});

export default ScheduleController;
